import { createLazyComponent } from '@muse-web/router'

export const AsyncUnsupportedFileDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'unsupported-file' */ './UnsupportedFileDialogContainer'),
    'UnsupportedFileDialogContainer',
)
